"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _roleCertificationApplication = require("@/api/user/roleCertificationApplication/roleCertificationApplication");
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
var _validators = _interopRequireDefault(require("@/components/Validate/validators"));
var _portConfigurationPH = _interopRequireDefault(require("@/componentsBuz/Associate/portConfigurationPH.vue"));
var _portConfiguration = _interopRequireDefault(require("@/componentsBuz/Associate/portConfiguration.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RoleApplicationAuthentication',
  components: {
    PortConfiguration: _portConfiguration.default,
    PortConfigurationPH: _portConfigurationPH.default
  },
  data: function data() {
    var _this = this;
    return {
      companyTypeList: [{
        labelZh: '货主',
        labelEn: 'Cargo Owner',
        value: 1
      }, {
        labelZh: '货代',
        labelEn: 'Forwarder',
        value: 2
      }, {
        labelZh: '车队',
        labelEn: 'Transport Team',
        value: 3
      }],
      edoUnitTypeList: [{
        labelZh: '订舱代理',
        labelEn: 'Booking Agency',
        value: 0
      }, {
        labelZh: '危险品申报单位',
        labelEn: 'Unit Department',
        value: 1
      }],
      customerTypeList: [{
        labelZh: '订舱代理',
        labelEn: 'CORPORATION/INCORPORATION',
        value: 0
      }, {
        labelZh: '个人企业',
        labelEn: 'SOLE PROPRIETORSHIP',
        value: 1
      }, {
        labelZh: '个人客户',
        labelEn: 'PERSONAL EFFECT (CONSGINED TO INDIVIDUAL) ',
        value: 2
      }],
      loading: false,
      isDisabled: true,
      editStatus: false,
      disabledEdit: false,
      businessLicenseScanningCopyDisabled: false,
      acceptList: '.jpg,.png,.pdf',
      uploadedBusinessLicenseFiles: [],
      uploadedEdoRecordFiles: [],
      roleDate: {},
      sysRole: [],
      termContent: '',
      termContentEn: '',
      bookingAgencies: [],
      filterForm: {
        companyType: '',
        companyName: '',
        usci: '',
        companyAbbrev: '',
        companyAddress: '',
        country: '',
        province: '',
        city: '',
        businessLicenseScanningCopy: '',
        isBookingJP: {
          sysRoleId: '',
          roleCode: '',
          jpBookingForwarderCode: '',
          jpBookingForwarderNameCn: '',
          jpBookingForwarderNameEn: '',
          contactMobilePhone: '',
          faxNo: '',
          emailCheck: '',
          faxCheck: '',
          rowStatus: '',
          portNameList: []
        },
        isBookingNonJP: {
          sysRoleId: '',
          roleCode: '',
          contactMobilePhone: '',
          taxNo: '',
          faxNo: '',
          emailCheck: '',
          faxCheck: '',
          portNameList: [],
          rowStatus: ''
        },
        isImportSwapBooking: {
          sysRoleId: '',
          roleCode: '',
          taxNo: '',
          contactMobilePhone: '',
          contactPhone: '',
          portCode: [],
          customerType: '',
          rowStatus: ''
        },
        isExportDangerousGoodsDeclaration: {
          sysRoleId: '',
          roleCode: '',
          edoUnitType: '',
          edoUserName: '',
          edoUserIdNumber: '',
          edoEmail: '',
          contactPhone: '',
          portNameList: [],
          rowStatus: ''
        }
      },
      checkedFields: [],
      rules: {
        companyType: [{
          required: true,
          message: this.$t('roleCertificationApplication.companyType') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        companyName: [{
          required: true,
          message: this.$t('roleCertificationApplication.companyName') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }, {
          validator: _validators.default.length({
            max: 200,
            title: this.$t('roleCertificationApplication.companyName')
          }),
          trigger: 'change'
        }],
        companyNameEn: [{
          required: true,
          message: this.$t('roleCertificationApplication.companyNameEn') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }, {
          validator: _validators.default.length({
            max: 200,
            title: this.$t('roleCertificationApplication.companyNameEn')
          }),
          trigger: 'change'
        }],
        usci: [{
          validator: this.validateUSCI,
          trigger: 'change'
        }, {
          validator: _validators.default.length({
            max: 50,
            title: this.$t('roleCertificationApplication.usci')
          }),
          trigger: 'change'
        }],
        companyAbbrev: [{
          required: true,
          message: this.$t('roleCertificationApplication.companyAbbrev') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }, {
          validator: _validators.default.length({
            max: 200,
            title: this.$t('roleCertificationApplication.companyAbbrev')
          }),
          trigger: 'change'
        }],
        companyAddress: [{
          required: true,
          message: this.$t('roleCertificationApplication.companyAddress') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }, {
          validator: _validators.default.length({
            max: 200,
            title: this.$t('roleCertificationApplication.companyAddress')
          }),
          trigger: 'change'
        }],
        country: [{
          required: true,
          message: this.$t('roleCertificationApplication.country') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        province: [{
          validator: _validators.default.length({
            max: 30,
            title: this.$t('roleCertificationApplication.province')
          }),
          trigger: 'change'
        }],
        city: [{
          validator: _validators.default.length({
            max: 30,
            title: this.$t('roleCertificationApplication.city')
          }),
          trigger: 'change'
        }],
        businessLicenseScanningCopy: [{
          validator: this.validateBusinessLicenseScanningCopy,
          trigger: 'change'
        }],
        'isBookingJP.jpBookingForwarderCode': [{
          required: true,
          message: this.$t('roleCertificationApplication.jpBookingForwarderCode') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        'isBookingJP.contactMobilePhone': [{
          required: true,
          message: this.$t('roleCertificationApplication.contactMobilePhone') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }, {
          validator: function validator(rule, value, callback) {
            var mobile = /^\d{1,20}$/;
            var tel = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{1,20}$/;
            if (mobile.test(value) || tel.test(value)) {
              callback();
            } else {
              callback(new Error(_this.$t('roleCertificationApplication.invalidPhone')));
            }
          },
          trigger: 'change'
        }],
        'isBookingJP.faxNo': [{
          required: true,
          message: this.$t('roleCertificationApplication.faxNo') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        'isBookingNonJP.contactMobilePhone': [{
          required: true,
          message: this.$t('roleCertificationApplication.contactMobilePhone') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }, {
          validator: function validator(rule, value, callback) {
            var mobile = /^\d{1,20}$/;
            var tel = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{1,20}$/;
            if (mobile.test(value) || tel.test(value)) {
              callback();
            } else {
              callback(new Error(_this.$t('roleCertificationApplication.invalidPhone')));
            }
          },
          trigger: 'change'
        }],
        'isExportDangerousGoodsDeclaration.contactMobilePhone': [{
          validator: function validator(rule, value, callback) {
            var mobile = /^\d{1,20}$/;
            var tel = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{1,20}$/;
            if (mobile.test(value) || tel.test(value)) {
              callback();
            } else {
              callback(new Error(_this.$t('roleCertificationApplication.invalidPhone')));
            }
          },
          trigger: 'change'
        }],
        'isBookingNonJP.portNameList': [{
          required: true,
          message: this.$t('roleCertificationApplication.portCode') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        'isImportSwapBooking.contactMobilePhone': [{
          required: true,
          message: this.$t('roleCertificationApplication.MobilePhone') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        'isImportSwapBooking.contactPhone': [{
          required: true,
          message: this.$t('roleCertificationApplication.contactPhone') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        'isImportSwapBooking.portCode': [{
          required: true,
          message: this.$t('roleCertificationApplication.portCode') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        'isImportSwapBooking.customerType': [{
          required: true,
          message: this.$t('roleCertificationApplication.customerType') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        'isExportDangerousGoodsDeclaration.edoEmail': [{
          required: true,
          message: this.$t('blExchangeAppointment.emailNotNull'),
          trigger: 'change'
        }, {
          type: 'email',
          message: this.$t('blExchangeAppointment.invalidEmail'),
          trigger: 'change'
        }, {
          pattern: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
          message: this.$t('blExchangeAppointment.invalidEmail'),
          trigger: 'change'
        }],
        'isExportDangerousGoodsDeclaration.portNameList': [{
          required: true,
          message: this.$t('roleCertificationApplication.portCode') + ' ' + this.$t('roleCertificationApplication.notBeEmpty'),
          trigger: 'change'
        }],
        agreedTerms: [{
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this.$t('roleCertificationApplication.agreeTerms')));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        agreedTerms1: [{
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this.$t('roleCertificationApplication.agreeTerms')));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {},
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])), {}, {
    isRequired: function isRequired() {
      return this.filterForm.country === 'CN';
    },
    emailCheckValue: {
      get: function get() {
        return this.filterForm.isBookingJP.emailCheck === 1;
      },
      set: function set(value) {
        this.filterForm.isBookingJP.emailCheck = value ? 1 : 0;
      }
    },
    faxCheckValue: {
      get: function get() {
        return this.filterForm.isBookingJP.faxCheck === 1;
      },
      set: function set(value) {
        this.filterForm.isBookingJP.faxCheck = value ? 1 : 0;
      }
    },
    isNonEmailCheckValue: {
      get: function get() {
        return this.filterForm.isBookingNonJP.emailCheck === 1;
      },
      set: function set(value) {
        this.filterForm.isBookingNonJP.emailCheck = value ? 1 : 0;
      }
    },
    isNonFaxCheckValue: {
      get: function get() {
        return this.filterForm.isBookingNonJP.faxCheck === 1;
      },
      set: function set(value) {
        this.filterForm.isBookingNonJP.faxCheck = value ? 1 : 0;
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;
    this.$refs.filterForm.resetFields();
    this.queryAuthenticationEdit();
    this.$dictionary.get(['BOOKING_AGENCY_JP'], true).then(function (res) {
      if (res.BOOKING_AGENCY_JP) {
        _this2.bookingAgencies = res.BOOKING_AGENCY_JP;
      }
    });
    this.loadInitialData();
    // 用户条款
    this.queryClause();
    this.handleEdit();
  },
  methods: {
    queryAuthenticationEdit: function queryAuthenticationEdit() {
      var _this3 = this;
      (0, _roleCertificationApplication.queryAuthenticationEdit)().then(function (res) {
        if (res.success) {
          _this3.isDisabled = res.data.status;
          _this3.filterForm.companyTypeDisabled = !!_this3.filterForm.companyType;
          _this3.filterForm.companyNameDisabled = !!_this3.filterForm.companyName;
          _this3.filterForm.companyNameEnDisabled = !!_this3.filterForm.companyNameEn;
          _this3.filterForm.usciDisabled = !!_this3.filterForm.usci;
          _this3.filterForm.companyAbbrevDisabled = !!_this3.filterForm.companyAbbrev;
          _this3.filterForm.companyAddressDisabled = !!_this3.filterForm.companyAddress;
          _this3.filterForm.countryDisabled = !!_this3.filterForm.country;
          _this3.filterForm.provinceDisabled = !!_this3.filterForm.province;
          _this3.filterForm.cityDisabled = !!_this3.filterForm.city;
          var data = _this3.filterForm;
          if (_this3.isDisabled && _this3.businessLicenseScanningCopyDisabled && data.companyTypeDisabled && data.companyNameDisabled && data.companyNameEnDisabled && data.usciDisabled && data.companyAbbrevDisabled && data.companyAddressDisabled && data.countryDisabled && data.provinceDisabled && data.cityDisabled) {
            _this3.filterForm.rowStatus = 2;
          } else {
            _this3.filterForm.rowStatus = 16;
          }
          _this3.$forceUpdate();
          // this.$set(this.form.formVgm[index],'vgmScale',1)
        }
      }).catch(function (err) {});
    },
    handleEdit: function handleEdit() {
      var _this4 = this;
      var editStatus = this.$route.query.editStatus;
      var status = JSON.parse(editStatus);
      this.editStatus = status;
      var ebSysAccount = this.$route.query.ebSysAccount;
      var account = JSON.parse(ebSysAccount);
      this.filterForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.filterForm), account);
      if (this.filterForm.businessLicenseScanningCopy) {
        this.businessLicenseScanningCopyDisabled = true;
        (0, _booking.getFileInfo)(this.filterForm.businessLicenseScanningCopy).then(function (res) {
          if (res.success && res.data) {
            _this4.uploadedBusinessLicenseFiles.push({
              name: res.data.fileName,
              url: res.data.fileUrl,
              fileId: res.data.fileId
            });
          }
        });
      }
      if (status) {
        this.disabledEdit = true;
        var accountPortRoleAuth = this.$route.query.ebSysAccountPortRoleAuth;
        if (accountPortRoleAuth) {
          this.roleDate = JSON.parse(accountPortRoleAuth);
          if (this.roleDate.roleCode === 'BOOKING_JP') {
            this.checkedFields.push('BOOKING_JP');
            this.filterForm.isBookingJP = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.filterForm.isBookingJP), this.roleDate);
            this.filterForm.isBookingJP.rowStatus = 16;
          }
          if (this.roleDate.roleCode === 'BOOKING_NOT_JP') {
            this.checkedFields.push('BOOKING_NOT_JP');
            this.filterForm.isBookingNonJP = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.filterForm.isBookingNonJP), this.roleDate);
            this.filterForm.isBookingNonJP.portNameList.push(this.roleDate.portCode);
            this.filterForm.isBookingNonJP.rowStatus = 16;
          }
          if (this.roleDate.roleCode === 'OUT_DG_DEC') {
            this.checkedFields.push('OUT_DG_DEC');
            this.filterForm.isExportDangerousGoodsDeclaration = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.filterForm.isExportDangerousGoodsDeclaration), this.roleDate);
            this.filterForm.isExportDangerousGoodsDeclaration.portNameList.push(this.roleDate.portCode);
            this.filterForm.isExportDangerousGoodsDeclaration.rowStatus = 16;
          }
          if (this.roleDate.roleCode === 'IN_EDO') {
            this.checkedFields.push('IN_EDO');
            this.filterForm.isImportSwapBooking = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.filterForm.isImportSwapBooking), this.roleDate);
            this.filterForm.isImportSwapBooking.portCode = this.roleDate.portCode ? [this.roleDate.portCode] : [];
            this.filterForm.isImportSwapBooking.rowStatus = 16;
            var edoRecordFileId = this.filterForm.isImportSwapBooking.edoRecordFileId;
            if (edoRecordFileId) {
              (0, _booking.getFileInfo)(edoRecordFileId).then(function (res) {
                if (res.success && res.data) {
                  _this4.uploadedEdoRecordFiles.push({
                    name: res.data.fileName,
                    url: res.data.fileUrl,
                    fileId: res.data.fileId
                  });
                }
              });
            }
          }
        }
      }
    },
    handleSelectChange: function handleSelectChange(value) {
      var selectedAgency = this.bookingAgencies.find(function (agency) {
        return agency.codeValue === value;
      });
      if (selectedAgency) {
        this.filterForm.isBookingJP.jpBookingForwarderNameCn = selectedAgency.displayValueCn;
        this.filterForm.isBookingJP.jpBookingForwarderNameEn = selectedAgency.displayValue;
      }
    },
    handleCheckboxChange: function handleCheckboxChange(value) {
      var _this5 = this;
      var selectedRoles = this.sysRole.filter(function (role) {
        return _this5.checkedFields.includes(role.roleCode);
      });
      selectedRoles.forEach(function (roleCode) {
        switch (roleCode.roleCode) {
          case 'BOOKING_JP':
            _this5.filterForm.isBookingJP.sysRoleId = roleCode.sysRoleId;
            _this5.filterForm.isBookingJP.roleCode = roleCode.roleCode;
            break;
          case 'BOOKING_NOT_JP':
            _this5.filterForm.isBookingNonJP.sysRoleId = roleCode.sysRoleId;
            _this5.filterForm.isBookingNonJP.roleCode = roleCode.roleCode;
            _this5.filterForm.isBookingNonJP.emailCheck = 1;
            break;
          case 'OUT_DG_DEC':
            _this5.filterForm.isExportDangerousGoodsDeclaration.sysRoleId = roleCode.sysRoleId;
            _this5.filterForm.isExportDangerousGoodsDeclaration.roleCode = roleCode.roleCode;
            break;
          case 'IN_EDO':
            _this5.filterForm.isImportSwapBooking.sysRoleId = roleCode.sysRoleId;
            _this5.filterForm.isImportSwapBooking.roleCode = roleCode.roleCode;
            break;
          default:
        }
      });
      if (!this.checkedFields.includes('BOOKING_JP')) {
        for (var key in this.filterForm.isBookingJP) {
          this.filterForm.isBookingJP[key] = '';
        }
        this.filterForm.isBookingJP.portNameList = [];
      }
      if (!this.checkedFields.includes('BOOKING_NOT_JP')) {
        for (var _key in this.filterForm.isBookingNonJP) {
          this.filterForm.isBookingNonJP[_key] = '';
        }
      }
      if (!this.checkedFields.includes('OUT_DG_DEC')) {
        for (var _key2 in this.filterForm.isExportDangerousGoodsDeclaration) {
          this.filterForm.isExportDangerousGoodsDeclaration[_key2] = '';
        }
      }
      if (!this.checkedFields.includes('IN_EDO')) {
        this.filterForm.isImportSwapBooking = {};
        for (var _key3 in this.filterForm.isImportSwapBooking) {
          this.filterForm.isImportSwapBooking[_key3] = '';
        }
      }
    },
    loadInitialData: function loadInitialData() {
      var _this6 = this;
      (0, _roleCertificationApplication.queryInfoRoleList)().then(function (res) {
        if (res.success) {
          _this6.sysRole = res.data;
        }
      }).catch(function (err) {});
    },
    queryClause: function queryClause() {
      var _this7 = this;
      (0, _roleCertificationApplication.queryClause)().then(function (res) {
        if (res.success) {
          _this7.termContent = res.data.termContent;
          _this7.termContentEn = res.data.termContentEn;
        }
      }).catch(function (err) {});
    },
    isChecked: function isChecked(value) {
      // 检查复选框是否被选中
      return this.checkedFields.includes(value);
    },
    validateUSCI: function validateUSCI(rule, value, callback) {
      if (this.filterForm.country === 'CN' && !value) {
        callback(new Error(this.$t('roleCertificationApplication.usci') + ' ' + this.$t('roleCertificationApplication.notBeEmpty')));
      } else {
        callback();
      }
    },
    handleDownload: function handleDownload(file) {
      var _this8 = this;
      if (!file.fileId) {
        return;
      }
      this.loading = (0, _utils.load)();
      (0, _booking.setDownloadFile)(file.fileId).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res]));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', res.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).finally(function () {
        _this8.loading.close();
      });
    },
    validateBusinessLicenseScanningCopy: function validateBusinessLicenseScanningCopy(rule, value, callback) {
      if (this.checkedFields.includes('IN_EDO') && !value) {
        callback(new Error(this.$t('roleCertificationApplication.businessLicenseScanningCopyNotNull')));
      } else {
        callback();
      }
    },
    transformFilterForm: function transformFilterForm(filterForm) {
      var ebSysAccount = {
        companyType: filterForm.companyType,
        companyName: filterForm.companyName,
        companyNameEn: filterForm.companyNameEn,
        companyAbbrev: filterForm.companyAbbrev,
        companyAddress: filterForm.companyAddress,
        country: filterForm.country,
        province: filterForm.province,
        city: filterForm.city,
        businessLicenseScanningCopy: filterForm.businessLicenseScanningCopy,
        usci: filterForm.usci,
        rowStatus: filterForm.rowStatus
      };
      var ebSysAccountPortRoleAuthDetailVoList = [];
      if (this.checkedFields.includes('BOOKING_JP') && Object.keys(filterForm.isBookingJP).some(function (key) {
        return filterForm.isBookingJP[key];
      })) {
        ebSysAccountPortRoleAuthDetailVoList.push({
          sysRoleId: filterForm.isBookingJP.sysRoleId,
          roleCode: filterForm.isBookingJP.roleCode,
          faxNo: filterForm.isBookingJP.faxNo,
          contactMobilePhone: filterForm.isBookingJP.contactMobilePhone,
          jpBookingForwarderCode: filterForm.isBookingJP.jpBookingForwarderCode,
          jpBookingForwarderNameCn: filterForm.isBookingJP.jpBookingForwarderNameCn,
          jpBookingForwarderNameEn: filterForm.isBookingJP.jpBookingForwarderNameEn,
          emailCheck: filterForm.isBookingJP.emailCheck,
          faxCheck: filterForm.isBookingJP.faxCheck,
          rowStatus: this.editStatus ? filterForm.isBookingJP.rowStatus : 4
        });
      }
      if (this.checkedFields.includes('BOOKING_NOT_JP') && Object.keys(filterForm.isBookingNonJP).some(function (key) {
        return filterForm.isBookingNonJP[key];
      })) {
        ebSysAccountPortRoleAuthDetailVoList.push({
          sysRoleId: filterForm.isBookingNonJP.sysRoleId,
          roleCode: filterForm.isBookingNonJP.roleCode,
          faxNo: filterForm.isBookingNonJP.faxNo,
          contactMobilePhone: filterForm.isBookingNonJP.contactMobilePhone,
          emailCheck: filterForm.isBookingNonJP.emailCheck,
          portNameList: filterForm.isBookingNonJP.portNameList,
          faxCheck: filterForm.isBookingNonJP.faxCheck,
          rowStatus: this.editStatus ? filterForm.isBookingNonJP.rowStatus : 4
        });
      }
      if (this.checkedFields.includes('IN_EDO') && Object.keys(filterForm.isImportSwapBooking).some(function (key) {
        return filterForm.isImportSwapBooking[key];
      })) {
        ebSysAccountPortRoleAuthDetailVoList.push({
          sysRoleId: filterForm.isImportSwapBooking.sysRoleId,
          roleCode: filterForm.isImportSwapBooking.roleCode,
          contactMobilePhone: filterForm.isImportSwapBooking.contactMobilePhone,
          contactPhone: filterForm.isImportSwapBooking.contactPhone,
          portNameList: filterForm.isImportSwapBooking.portCode,
          edoRecordFileId: filterForm.isImportSwapBooking.edoRecordFileId,
          rowStatus: this.editStatus ? filterForm.isImportSwapBooking.rowStatus : 4
        });
      }
      if (this.checkedFields.includes('OUT_DG_DEC') && Object.keys(filterForm.isExportDangerousGoodsDeclaration).some(function (key) {
        return filterForm.isExportDangerousGoodsDeclaration[key];
      })) {
        ebSysAccountPortRoleAuthDetailVoList.push({
          sysRoleId: filterForm.isExportDangerousGoodsDeclaration.sysRoleId,
          roleCode: filterForm.isExportDangerousGoodsDeclaration.roleCode,
          edoUnitType: filterForm.isExportDangerousGoodsDeclaration.edoUnitType,
          edoUserName: filterForm.isExportDangerousGoodsDeclaration.edoUserName,
          edoUserIdNumber: filterForm.isExportDangerousGoodsDeclaration.edoUserIdNumber,
          edoEmail: filterForm.isExportDangerousGoodsDeclaration.edoEmail,
          contactPhone: filterForm.isExportDangerousGoodsDeclaration.contactPhone,
          portNameList: filterForm.isExportDangerousGoodsDeclaration.portNameList,
          rowStatus: this.editStatus ? filterForm.isExportDangerousGoodsDeclaration.rowStatus : 4
        });
      }
      return {
        ebSysAccount: ebSysAccount,
        ebSysAccountPortRoleAuthDetailVoList: ebSysAccountPortRoleAuthDetailVoList
      };
    },
    onSubmit: function onSubmit() {
      var _this9 = this;
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          if (_this9.checkedFields.includes('IN_EDO') && !_this9.filterForm.isImportSwapBooking.edoRecordFileId && _this9.filterForm.isImportSwapBooking.portCode && Array.isArray(_this9.filterForm.isImportSwapBooking.portCode) && _this9.filterForm.isImportSwapBooking.portCode.some(function (code) {
            return !['CNXMN', 'CNNSA', 'CNYPG'].includes(code);
          })) {
            _this9.$message.error(_this9.$t('roleCertificationApplication.importEdoPromise') + ' ' + _this9.$t('roleCertificationApplication.notBeEmpty'));
            return;
          }
          var data = _this9.transformFilterForm(_this9.filterForm);
          _this9.loading = (0, _utils.load)();
          (0, _roleCertificationApplication.ebSysAccountPortRoleAuthSaveInfo)(data).then(function (res) {
            if (res.success) {
              _this9.$message.success(_this9.$t('roleCertificationApplication.saveSuccessfully'));
              setTimeout(function () {
                var data = {
                  view: _this9.$route
                };
                // 关闭当前路由
                _this9.$store.dispatch('tagsView/detailTabDelete', data);
                _this9.$router.push({
                  path: '/userCenter/roleCertificationApplication'
                });
              }, 500);
            } else {
              if (res.errorMessages && res.errorMessages.length > 0) {
                res.errorMessages.forEach(function (errorMessage) {
                  _this9.$message.error(errorMessage);
                });
              } else {
                _this9.$message.error('发生未知错误');
              }
            }
          }).catch(function (err) {
            console.log('错误返回值==============');
            console.log(err);
          }).finally(function () {
            _this9.loading.close();
          });
        }
      });
    },
    uploadFile: function uploadFile(item, type) {
      var _this10 = this;
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append('file', item.file);
      formDatas.append('bucket', 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          if (type === 'edo') {
            _this10.filterForm.isImportSwapBooking.edoRecordFileId = res.fileId;
            _this10.uploadedEdoRecordFiles.push({
              name: item.file.name,
              url: res.fileUrl,
              fileId: res.fileId
            });
          } else if (type === 'businessLicense') {
            _this10.filterForm.businessLicenseScanningCopy = res.fileId;
            _this10.uploadedBusinessLicenseFiles.push({
              name: item.file.name,
              url: res.fileUrl,
              fileId: res.fileId
            });
          }
        } else {
          _this10.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this10.loading.close();
      });
    },
    beforeRemove: function beforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    beforeRemoveBusinessLicense: function beforeRemoveBusinessLicense(file) {
      if (!this.businessLicenseScanningCopyDisabled) {
        return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
      } else if (this.isDisabled) {
        return false;
      } else {
        return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
      }
    },
    downloadEdoPromise: function downloadEdoPromise(portCode) {
      var link = document.createElement('a');
      // 确保portCode是字符串
      var port = Array.isArray(portCode) ? portCode[0] : portCode;
      if (port === 'CNNGB') {
        link.href = '/static/pdf/EdoRecord(CNNGB).pdf';
        link.download = 'EdoRecord(CNNGB).pdf';
        link.click();
      } else if (port === 'CNSHA') {
        link.href = '/static/pdf/EdoRecord(CNSHA).pdf';
        link.download = 'EdoRecord(CNSHA).pdf';
        link.click();
      } else if (port === 'CNSHK') {
        link.href = '/static/pdf/EdoRecord(CNSHK).pdf';
        link.download = 'EdoRecord(CNSHK).pdf';
        link.click();
      } else if (port === 'CNTAO') {
        link.href = '/static/pdf/EdoRecord(CNTAO).pdf';
        link.download = 'EdoRecord(CNTAO).pdf';
        link.click();
      } else if (port === 'CNTXG') {
        link.href = '/static/pdf/EdoRecord(CNTXG).pdf';
        link.download = 'EdoRecord(CNTXG).pdf';
        link.click();
      } else if (port === 'CNXMN') {
        link.href = '/static/pdf/EdoRecord(CNXMN)1.0.pdf';
        link.download = 'EdoRecord(CNXMN).pdf';
        link.click();
      } else if (port !== null && port !== void 0 && port.startsWith('PH')) {
        link.href = '/static/pdf/Letter of Commitment .pdf';
        link.download = 'Letter of Commitment.pdf';
        link.click();
      }
    },
    handleRemove: function handleRemove(file, type) {
      var _this11 = this;
      var fileId;
      if (type === 'edo') {
        fileId = this.filterForm.isImportSwapBooking.edoRecordFileId;
      } else if (type === 'businessLicense') {
        fileId = this.filterForm.businessLicenseScanningCopy;
      }
      if (!fileId) {
        return;
      }
      this.loading = (0, _utils.load)();
      (0, _booking.deleteByFileId)(fileId).then(function (res) {
        if (res) {
          if (type === 'edo') {
            _this11.filterForm.isImportSwapBooking.edoRecordFileId = null;
            _this11.uploadedEdoRecordFiles = _this11.uploadedEdoRecordFiles.filter(function (item) {
              return item.fileId !== fileId;
            });
          } else if (type === 'businessLicense') {
            _this11.filterForm.businessLicenseScanningCopy = null;
            _this11.uploadedBusinessLicenseFiles = _this11.uploadedBusinessLicenseFiles.filter(function (item) {
              return item.fileId !== fileId;
            });
          }
          _this11.$message.success(_this11.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this11.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this11.loading.close();
      });
    },
    updateCustomerTypeRule: function updateCustomerTypeRule() {
      // 确保portCode是数组再使用some方法
      var portCode = this.filterForm.isImportSwapBooking.portCode || [];
      this.rules['isImportSwapBooking.customerType'][0].required = Array.isArray(portCode) && portCode.some(function (code) {
        return code && code.startsWith('PH');
      });
      this.$refs['filterForm'].clearValidate('isImportSwapBooking.customerType'); // 清除之前的验证信息
    }
  }
};